import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ baseURL: API, withCredentials: true });

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = admin
  const [bearer, setBearer] = useState(() => localStorage.getItem("elenem_token") || null);

  // Attach bearer fallback so first-visit-after-login works if cookies are blocked
  useEffect(() => {
    if (bearer) {
      api.defaults.headers.common["Authorization"] = `Bearer ${bearer}`;
    } else {
      delete api.defaults.headers.common["Authorization"];
    }
  }, [bearer]);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (!cancelled) setUser(data);
      } catch {
        if (!cancelled) setUser(false);
      }
    };
    check();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bearer]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.token) {
      localStorage.setItem("elenem_token", data.token);
      setBearer(data.token);
    }
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {
      // ignore — we're clearing state regardless
    }
    localStorage.removeItem("elenem_token");
    setBearer(null);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, api }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
